(function ($) {

    var accountsFactory = function () {
        return {
            httpRequest: null,

            createService: function () {
                var accounts = $.cdh.accounts;
                var result = $.cdh.helper.clone(accounts);
                result.httpRequest = null;
                return result;
            },

            initHttpRequest: function (convertFunc) {
                if (convertFunc)
                    this.httpRequest = new $.cdh.get.accounts.list(convertFunc);
                else
                    this.httpRequest = new $.cdh.get.accounts.list();

                return this.httpRequest;
            },

            initAccountsWithConverting: function (convertFunc, skipCache) {
                return this.initAccounts(null, skipCache, convertFunc);
            },

            initAccounts: function (onLoadCallback, skipCache, convertFunc) {
                this.initHttpRequest(convertFunc);

                if (this.httpRequest.hasData()) {
                    this.httpRequest.setData(null);
                }

                this.httpRequest.load()
                    .done(function () {
                        if (onLoadCallback) {
                            onLoadCallback(this.httpRequest.data());
                        }
                    }.bind(this));

                return this.httpRequest;
            },


            list: function () {
                return this.httpRequest.rawData();
            },

            listCurrent: function () {
                var accounts = $.grep(this.list(),
                    function (a) {
                        if (a.AccountPlanYear === $.cdh.enums.planYear.current) {
                            return true;
                        }
                        return false;
                    });
                return accounts;
            },

            anyCurrent: function () {
                return this.listCurrent().length > 0;
            },

            listHsa: function () {
                var hsaAccounts = $.grep(this.list(),
                    function (a) {
                        // Added code change to fix, in tax forms VEBA account should not list in dropdown
                        if (a.AccountType === $.cdh.enums.accountType.hsa && !a.IsVeba) {
                            return true;
                        }
                        return false;
                    });
                return hsaAccounts;
            },

            listHsaCurrent: function() {
                var hsaAccounts = $.grep(this.listHsa(),
                    function (a) {
                        if (a.AccountPlanYear === $.cdh.enums.planYear.current) {
                            return true;
                        }
                        return false;
                    });
                return hsaAccounts;
            },


            listHsaCurrentExceptVeba: function() {
                var accounts = $.grep(this.listHsaCurrent(),
                    function (a) {
                        if (a.AccountTypeClass !== $.cdh.enums.accountTypeClass.veba) {
                            return true;
                        }
                        return false;
                    });
                return accounts;
            },


            anyHsaCurrent: function() {
                return this.listHsaCurrent().length > 0;
            },

            listNonHsa: function() {
                var nonHsaAccounts = $.grep(this.list(),
                    function (a) {
                        if (a.AccountType !== $.cdh.enums.accountType.hsa) {
                            return true;
                        }
                        return false;
                    });
                return nonHsaAccounts;
            },

            listNonHsaCurrent: function () {
                var hsaAccounts = $.grep(this.listNonHsa(),
                    function (a) {
                        if (a.AccountPlanYear === $.cdh.enums.planYear.current) {
                            return true;
                        }
                        return false;
                    });
                return hsaAccounts;
            },

            listAddClaimAllowedCurrent: function () {
                var accountsAddClaimAllowed = $.grep(this.listCurrent(),
                    function (a) {
                        if (a.AddClaimAllowed) {
                            return true;
                        }
                        return false;
                    });
                return accountsAddClaimAllowed;
            },
            anyNonHsa: function () {
                return this.listNonHsa().length > 0;
            },
            anyHsa: function () {
                return this.listHsa().length > 0;
            },
            anyNonHsaCurrent: function() {
                return this.listNonHsaCurrent().length > 0;
            },

            count: function () {
                return this.list().length;
            },

            byAccountId: function(accountId) {
                var accounts =  this.list().filter(function(a) {
                    return a.AccountId == accountId;
                });

                if (accounts.length > 0)
                    return accounts[0];

                return null;
            },

            countCurrent: function () {
                return $.grep(this.list(), this.isCurrentAccountByDates).length;
            },

            isCurrentAccountByDates: function(account) {
                var start = moment.utc(account.PlanStartDate);
                var end = moment.utc(account.PlanEndDate);
                var date = moment.utc();
                if (start < date && date < end)
                    return true;
                return false;
            },

            isFutureAccountByDates: function(account) {
                var start = moment.utc(account.PlanStartDate);
                var date = moment.utc();
                if (start > date)
                    return true;
                return false;
            },

            isPreviousAccountByDates: function(account) {
                var end = moment.utc(account.PlanEndDate);
                var date = moment.utc();
                if (end < date)
                    return true;
                return false;
            },

            listBillPayEnabled: function () {
                var billPayEnabledAccounts = $.grep(this.list(),
                    function (a) {
                        if (a.BillPayEnabled) {
                            return true;
                        }
                        return false;
                    });
                return billPayEnabledAccounts;
            },

            anyBillPayEnabled: function () {
                return this.listBillPayEnabled().length > 0;
            },

            anyBillPayEnabledCurrent: function () {
                return $.grep(this.listBillPayEnabled(),
                    function (a) {
                        return a.AccountPlanYear == $.cdh.enums.planYear.current;
                    }).length >
                    0;
            },

            listManualClaimsEnabled: function () {
                var manualClaimEnabledAccounts = $.grep(this.list(),
                    function (a) {
                        if (a.ManualClaimsEnabled) {
                            return true;
                        }
                        return false;
                    });
                return manualClaimEnabledAccounts;
            },

            anyManualClaimsEnabled: function() {
                return this.listManualClaimsEnabled().length > 0;
            },

            anyManualClaimsEnabledCurrent: function() {
                return $.grep(this.listManualClaimsEnabled(),
                        function (a) {
                            return a.AccountPlanYear == $.cdh.enums.planYear.current;
                        }).length >
                    0;
            },

            listNonBillPayEnabled: function () {
                var nonBillPayEnabledAccounts = $.grep(this.list(),
                    function (a) {
                        if (a.BillPayEnabled) {
                            return false;
                        }
                        return true;
                    });
                return nonBillPayEnabledAccounts;
            },

            anyNonBillPayEnabled: function () {
                return this.listNonBillPayEnabled().length > 0;
            },

            anyNonBillPayEnabledCurrent: function () {
                return $.grep(this.listNonBillPayEnabled(),
                    function (a) {
                        return a.AccountPlanYear == $.cdh.enums.planYear.current;
                    }).length >
                    0;
            },

            eligibilityDate: function () {
                var accountsWithEligibilityDate = $.grep(this.list(),
                    function (a) {
                        if (a.ShowEligibilityDate) {
                            //Check that we don't have other same type accounts

                            var sameTypeAccounts = $.grep(this.list(),
                                function(acc) {
                                    return acc.AccountType == a.AccountType && acc.AccountId != a.AccountId;
                                });
                            if (sameTypeAccounts.length == 0)
                                return true;

                            //Check the other accounts is current by their start and end date
                            //If so, don't use eligibility date from this account
                            var activeAccounts = $.grep(sameTypeAccounts,
                                function(acc) {
                                    return this.isCurrentAccountByDates(acc);
                                }.bind(this)).length;
                            if (activeAccounts > 0)
                                return false;

                            return true;
                        }
                        else return false;
                    }.bind(this));
                
                if (accountsWithEligibilityDate.length > 0) {
                    var accountsWithMinEligibilityDate = accountsWithEligibilityDate.sort(function(a, b) {
                        var aDate = moment(a.EligibilityDate);
                        var bDate = moment(b.EligibilityDate);
                        return ((aDate < bDate) ? -1 : ((aDate > bDate) ? 1 : 0));

                    });
                    return accountsWithMinEligibilityDate[0].EligibilityDate;
                }
                return null;
            },

            isVeba: function(account) {
	            return account && account.AccountTypeClass == $.cdh.enums.accountTypeClass.veba;
            },

            validateCache: function (account) {
                if (!account) return;
                var cacheKey = "accountsList_" + $.cdh.user.uniqueHash;
                var cachedAccounts = $.cdh.helper.getObjectFromLocalStorage(cacheKey);
                if (!cachedAccounts) return;

                function cleanCache() {
                    $.cdh.helper.setObjectToLocalStorage(cacheKey, null, 0);
                }

                var foundInCache = $.grep(cachedAccounts, function (x) { return x.AccountId === account.AccountId });
                if (foundInCache.length !== 1) return; // Something wrong here. User can't open new account from the old cache
                if (foundInCache[0].BillPayEnabled != account.BillPayEnabled) return cleanCache();
            }
        }
    }
    var accounts = accountsFactory();

    $.extend(true, $, {
        cdh: {
            accounts: accounts,
            accountsFactory: accountsFactory
        }
    });
})(jQuery);